import { Component, inject, Input } from '@angular/core';
import { Router } from '@angular/router';
import { KeycloakService } from 'keycloak-angular';
import { ButtonComponent } from '@shared/components/button/button.component';
import { Rol } from '@core/models/user';
import { AuthService } from '@core/services/auth.service';

@Component({
  selector: 'app-header',
  imports: [ButtonComponent],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
})
export class HeaderComponent {
  auth = inject(AuthService);
  keycloakService = inject(KeycloakService);
  router = inject(Router);
  Roles = Rol;

  @Input() showHeader: boolean;

  logout() {
    this.auth.logout();
  }

  goToAdmin() {
    this.router.navigateByUrl('/admin');
  }
}
